module.exports = __webpack_public_path__ + "static/media/thumbnail.13a57c4b.webp";